/**
 * Created by Thomas Mark
 * Date: 2021-04-02
 * 
 * Hier können zum einen Schlagwörter verwaltet werden und zum anderen
 * können diese Schlagwörter dann einem Produkt zugeordnet werden.
 * 
 * Der Dialog steht nur im ADMIN-Modus zur Verfügung und über das
 * Toolbar "Filter / Schlagwörter" im Produkt-Detailsdialog gestartet
 * werden.
 *   
 */
import React from 'react';
import { bindActionCreators } from "redux";

import { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';

import * as utils from "../../../basics/utils";
import * as cordova from "../../../basics/cordova";
import * as appActions from "../../../store/actions/appActions";
import * as fileActions from "../../../store/actions/fileActions";
import * as settingActions from "../../../store/actions/settingActions";
import * as portfolioActions from "../../../store/actions/portfolioActions";
import { ModalTitle } from "../../partials/ModalTitle";

const ImageTagsModal = () => {
    const debug = false;

    const app = useSelector((state) => state.app);
    const { modalDialog, appModus, unitHeight, path, galleryIndex, galleryTimestamp } = app;

    const portfolio = useSelector((state) => state.portfolio);
    const { currentPortfolio, currentProduct } = portfolio;

    const setting = useSelector((state) => state.setting);
    const { tagSettings } = setting;

    const dispatch = useDispatch();
    const { uploadJSON } = bindActionCreators(fileActions, dispatch);
    const { setModalDialog, closeModalDialog, setGalleryTimestamp } = bindActionCreators(appActions, dispatch);
    const { scanPortfolio, setCurrentProduct } = bindActionCreators(portfolioActions, dispatch);
    const { setTagSettings, setTagSettingsCurrent, updateSetting } = bindActionCreators(settingActions, dispatch);

    const dialog = utils.getDialogByPath(path);

    const initialState = {
        tabIndex: 0,
        editMode: false,
        newTag: '',
        imageTags: [],
        validationError: false,
        validationMessage: "",
    }

    const [state, setState] = useState(initialState);

    const { imageTags, newTag, editMode, validationMessage } = state;

    const itemHeight = unitHeight;

    const getImagesJSON = () => {
        const productList = utils.getTree(path);

        const imagesJSON = productList.filter(d => d.name === 'images.json')
        if (imagesJSON.length > 0) {
            if (imagesJSON[0]['images']) {
                return imagesJSON[0]['images'];
            } else {
                return [];
            }
        }
        return [];
    }

    const [imagesJSON, setImagesJSON] = useState(getImagesJSON());

    // ==========================================================================
    //
    // HELPER - SECTION
    //
    // ==========================================================================
    const doUploadJSON = (newImagesJSON) => {
        //const { currentProduct } = portfolio;

        uploadJSON(path, 'images.json', newImagesJSON, () => {
            console.log('uploadJSON(images.json) success', newImagesJSON);
            scanPortfolio(dialog.portfolio);
            //setCurrentProduct(currentProduct);
        }, (error) => {
            console.log('uploadJSON(images.json) error:', error);
        });
    }

    const getImageUrl = (path, file) => {
        if (appModus === 'Admin') {
            return utils.getURL('product', path, file);

        } else {
            const data = cordova.getImageFromBuffer(path, file);
            return window.URL.createObjectURL(data);
        }
    }

    const validateWidget = (id, value) => {
        debug && console.log(`validateWidget(${id}, ${value})`);

        const pruefeText = (text) => {
            const regex = /^[a-zA-ZäöüÄÖÜß0-9]+$/;
            return regex.test(text);
        }

        // Feld 'name' prüfen
        if (id === 'name') {
            if (!pruefeText(value) && value.length > 0) {
                console.log('Wert ist ungültig!');
                const newState = { validationError: true, validationMessage: 'Wert ist ungültig!' };
                setState({ ...state, newState });
                return false
            } else {
                const newState = { validationError: false, validationMessage: '' };
                setState({ ...state, newState });
                return true;
            }
        }
    }

    // ==========================================================================
    //
    // LIFESYCLE - SECTION
    //
    // ==========================================================================

    /**
     * 
     * Schlagwörter aus dem aktuellen Bild auslesen
     * Dies muss immer dann gemacht werden, wenn:
     * - das Produkt neu verändert wurde (currentProduct)
     * - ein Bild im Produkt selektiert wurde (galleryIndex) 
     * - dieser Dialog geöffnet oder geschlossen wurde (modalDialog)
     * 
     */
    useEffect(() => {
        console.log('ImageTagsModal:useEffect([modalDialog, galleryTimestamp, galleryIndex])')

        const newImagesJSON = getImagesJSON();
        console.log('newImagesJSON:', newImagesJSON);

        setImagesJSON(newImagesJSON);

        if (newImagesJSON.length > 0) {
            if (newImagesJSON[galleryIndex] !== undefined && newImagesJSON[galleryIndex]['tags'] !== undefined) {
                console.log('newImagesJSON[galleryIndex]:', newImagesJSON[galleryIndex])
                console.log('tags:', newImagesJSON[galleryIndex]['tags'])
                setState({ ...state, imageTags: newImagesJSON[galleryIndex]['tags'] })
            } else {
                setState({ ...state, imageTags: [] })
            }
        }
    }, [modalDialog, galleryTimestamp, galleryIndex, currentProduct]);

    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================



    const onCancel = () => {
        closeModalDialog(); // appAction.js
    }

    // ==========================================================================
    // 
    // SUB RENDER
    // 
    // ==========================================================================

    const renderTag = (d, i) => {

        const checkFilter = (filter) => {

            const filterResult = imageTags.filter(value => value === filter)

            return filterResult.length > 0 ? true : false;
        }

        const styleStandard = { backgroundColor: 'rgb( 64, 66,  65)', color: 'white' };

        if (editMode) {

            const onDelete = () => {
                let newTagSettings = tagSettings;
                let newImage = tagSettings['image']

                newImage = tagSettings['image'].filter(v => v !== d);

                newTagSettings['image'] = newImage;

                setTagSettings(newTagSettings);
            }

            const style = Object.assign(styleStandard, utils.getStyleHeight(itemHeight, .45, .32, .25));

            return (
                <div key={i} className="inline-block rounded px-2 py-1 mr-2 whitespace-no-wrap overflow-hidden" style={style} onClick={onDelete}>
                    <span>{d}&nbsp;×</span>
                </div>
            )

        } else {

            const onSelect = () => {
                let newImageTags = imageTags;

                checkFilter(d) ? newImageTags = imageTags.filter(v => v !== d) : newImageTags.push(d);

                setState({ ...state, imageTags: newImageTags })
            }

            const styleSelected = { backgroundColor: 'rgb(58, 133, 247)', color: 'white' };
            const style = Object.assign((checkFilter(d)) ? styleSelected : styleStandard, utils.getStyleHeight(itemHeight, .45, .32, .25));

            return (
                <div key={i} className="inline-block bg-gray-200 rounded px-2 py-1 mr-2 whitespace-no-wrap overflow-hidden"
                    style={style} onClick={(e) => onSelect()}>{d}
                </div>
            )
        }
    }

    const renderAddTag = () => {
        if (!editMode) return null;

        const onSubmit = (e) => {
            e.preventDefault();

            // nicht sichern, wenn Feld fehlerhaft!
            if (validationMessage !== '') return;

            let newTagSettings = tagSettings;

            // Falls noch keine image-Objekt in settings.json existiert
            if (newTagSettings['image'] === undefined) {
                newTagSettings['image'] = [];
            }

            if (newTagSettings['image'].filter(v => v === newTag).length === 0) {
                // newTag zur Tag-Gruppe hinzufügen
                newTagSettings['image'].push(newTag);

                // CurrentSetting aktualisieren
                setTagSettingsCurrent(newTagSettings);

                // Feld zurücksetzen
                setState({ ...state, newTag: '' });
            }
        }

        const onChange = (e) => {
            console.log('onChange()', e.target.value)

            if (validateWidget(e.target.id, e.target.value)) {
                setState({ ...state, newTag: e.target.value });
            }
        }

        return (
            <form className={"w-full"} noValidate onSubmit={onSubmit}>
                <FormControl className={""}>
                    <TextField
                        autoFocus
                        id="name"
                        autoComplete="off"
                        label="Neues Schlagwort"
                        type="text"
                        fullWidth={false}
                        disabled={false}
                        value={newTag}
                        onChange={onChange}
                        InputLabelProps={{ shrink: true }}
                        margin="normal"
                    />
                </FormControl>
            </form>
        )
    }

    const renderToolbar = () => {

        const onToggleEditMode = () => {
            setState({ ...state, editMode: !editMode });
        }

        const onSave = () => {
            const newImagesJSON = imagesJSON;

            newImagesJSON[galleryIndex]['tags'] = imageTags;

            doUploadJSON(newImagesJSON);

            onCancel();
        }

        const onSaveSettings = () => {
            updateSetting('tags', tagSettings);

            setState({ ...state, editMode: !editMode });
        }

        const onOpenGallery = () => {
            setModalDialog('ImageGalleryModal', '');
        }

        if (editMode) {
            return (
                <DialogActions>
                    <Button onClick={onToggleEditMode} variant="outlined" color="default" >Abbruch</Button>
                    <Button onClick={onSaveSettings} variant="contained" color="primary">OK</Button>
                </DialogActions>
            )
        } else {
            return (
                <DialogActions>
                    <Button onClick={onToggleEditMode} variant="outlined" color="default">Schlagwörter verwalten</Button>
                    <Button onClick={onOpenGallery} variant="outlined" color="default" >Galerie öffnen</Button>
                    <div className="flex-grow"></div>
                    <Button onClick={onCancel} variant="outlined" color="default" >Abbruch</Button>
                    <Button onClick={onSave} variant="contained" color="default" >OK</Button>
                </DialogActions>
            )
        }
    }

    const renderGalleryImage = () => {

        if (imagesJSON.length === 0) return null;
        if (galleryIndex >= imagesJSON.length) return null;

        const image = imagesJSON[galleryIndex];

        if (image === undefined) return null;

        return (
            <div className={`absolute top-0`}>
                <img src={getImageUrl(path, image.file)} alt="" style={{ objectFit: "cover" }} />
            </div>
        )
    }

    /**
     * 
     * Hier wird ein milchiger Hintergrund erzeugt, der dynamisch mit den vorhandenen 
     * Schlagwärtern mitwächast. Hierzu werden die Schlagwörter unsichtbar angezeigt.
     * 
     */
    const renderTagsBackground = () => {
        return (
            <div className="min-w-full absolute top-0 p-4 bg-gray-200 opacity-50 " >
                {tagSettings?.image?.map((d, i) => renderTag(d, i))}
            </div>
        )
    }

    /**
     * 
     * Hier werden alle Schlagwörter angezeigt 
     * 
     */
    const renderImageTags = () => {

        return (
            <div className="absolute top-0 p-4" >
                {tagSettings?.image?.map((d, i) => renderTag(d, i))}
            </div>

        )
    }

    // ==========================================================================
    // 
    // MAIN RENDER
    // 
    // ==========================================================================
    if (modalDialog.dialog !== 'ImageTagsModal') return null;

    if (!tagSettings) return null;

    const dialogTitle = 'Bild-Schlagwörter ' + (editMode ? 'verwalten' : '');

    console.log('imagesJSON:', imagesJSON);

    return (
        <div>
            <Dialog fullWidth={true} maxWidth="md" open={true} style={{ zIndex: 100 }}>
                <ModalTitle onClose={onCancel}>{dialogTitle}</ModalTitle>
                <div className="p-4" >
                    {renderAddTag()}
                </div>
                <DialogContent dividers>

                    <div className="relative" style={{ minHeight: 700 }}>
                        {renderGalleryImage()}
                        {renderTagsBackground()}
                        {renderImageTags()}
                    </div>
                </DialogContent>
                {renderToolbar()}
                <Typography className="w-full px-8" variant="h6" noWrap>
                    {validationMessage === '' ? <span>&nbsp;</span> : validationMessage}
                </Typography>

            </Dialog>
        </div>
    );
}

export default ImageTagsModal;